import { ModulePageOutput } from 'module/model/page/module-page.output';
import { ModulePage } from 'module/page/module-page';

export abstract class ModulePageConverterPort {
	public abstract asModulePage(output: ModulePageOutput): ModulePage;
}
